export class AzureVmInstanceRestoreDestination {
    'azureVm';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "azureVm",
            "baseName": "azureVm",
            "type": "AzureVmInstanceRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVmInstanceRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
